/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestCreateStory } from '../model/models';
import { ApiResponseStory } from '../model/models';
import { ApiResponseUnseenAndLastPublishedStory } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface StoryServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestCreateStory 
     */
    storyControllerCreateStory0(apiRequestCreateStory: ApiRequestCreateStory, extraHttpRequestParams?: any): Observable<ApiResponseStory>;

    /**
     * 
     * 
     * @param apiRequestCreateStory 
     */
    storyControllerCreateStory1(apiRequestCreateStory: ApiRequestCreateStory, extraHttpRequestParams?: any): Observable<ApiResponseStory>;

    /**
     * 
     * 
     */
    storyControllerGetLatestAndUnseenStories0(extraHttpRequestParams?: any): Observable<ApiResponseUnseenAndLastPublishedStory>;

    /**
     * 
     * 
     */
    storyControllerGetLatestAndUnseenStories1(extraHttpRequestParams?: any): Observable<ApiResponseUnseenAndLastPublishedStory>;

    /**
     * 
     * 
     * @param storyId 
     */
    storyControllerMarkStorySeen0(storyId: string, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param storyId 
     */
    storyControllerMarkStorySeen1(storyId: string, extraHttpRequestParams?: any): Observable<{}>;

}
